import { render, staticRenderFns } from "./GroupItemAdd.vue?vue&type=template&id=9d57e8da"
import script from "./GroupItemAdd.vue?vue&type=script&lang=js"
export * from "./GroupItemAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports